import { FC, useEffect, useState } from 'react';

import { Game } from '@/components/Game';
import { Training } from '@/components/Training';
import { LandScape } from '@/components/LandScape';

const App: FC = () => {
  const [step, setStep] = useState(1);
  const [configId, setConfigId] = useState<string>('');
  const [totalPoints, setTotalPoints] = useState<number>(0);
  const [userToken, setUserToken] = useState<string>('');

  useEffect(() => {
    window.jticonnexus.init().then(({ config, user }) => {
      setConfigId(config.id);
      setTotalPoints(config.max_points);
      setUserToken(user._id);
    });
  }, []);

  return (
    <>
      <LandScape />
      <Training
        step={step}
        setStep={setStep}
        totalPoints={totalPoints}
        userToken={userToken}
      />
      <Game
        step={step}
        setStep={setStep}
        totalPoints={totalPoints}
        configId={configId}
        userToken={userToken}
      />
    </>
  );
};

export default App;
